import Lottie from 'lottie-react';

import wine from '../jsons/Wine.json';

const Wine = props => {
  return <Lottie animationData={wine} {...props} />;
};

export default Wine;
